module.exports = __webpack_public_path__ + "static/media/max.d9c648f0.svg";